<template>
  <Article>
    <Heading as="h1">
      <!--  -->
      Healthcare Litigation
    </Heading>
    <p>
      The attorneys of Hobson Bernardino + Davis have been in the lead on
      cutting-edge issues facing the healthcare industry. We have the breadth
      that few law firms can offer to their clients and have represented clients
      in federal and state courts, licensing proceedings and government
      investigations.
    </p>
    <p>
      The firm’s lawyers have represented healthcare organizations, physicians,
      pharmacists, dentists, nurses, home healthcare agencies, medical
      transportation providers and medical equipment supply companies.
    </p>
    <Heading as="h2">
      <!--  -->
      Range of Litigation Services for Healthcare Providers
    </Heading>
    <p>
      Our clients can rely on us to effectively defend them in government or qui
      tam actions brought under the federal anti-kickback statute, False Claims
      Act, RICO and SEC allegations. Our representation may commence with an
      internal compliance audit, a governmental audit or investigation, a
      third-party payor audit or investigation, the filing of a lawsuit, the
      filing of an indictment or criminal complaint, the execution of a search
      warrant, or upon receipt of a subpoena from a federal or state agency. We
      understand the devastating impact that these events can have on a provider
      and we work quickly and efficiently to resolve the problem.
    </p>
    <Heading as="h2">
      <!--  -->
      Hobson Bernardino + Davis Provides High Quality Healthcare-Law
      Representation
    </Heading>
    <p>
      The healthcare lawyers at Hobson Bernardino + Davis are highly
      accomplished attorneys with the kind of experience, education and
      interests that define exceptional representation. In the last few years,
      our lawyers have represented healthcare providers before licensing
      agencies, state courts, United States District Courts, the United States
      Judicial Panel on Multidistrict Litigation, the Ninth Circuit Court of
      Appeals and the United States Supreme Court.
    </p>
    <Heading as="h2">
      <!--  -->
      Featured Experience
    </Heading>
    <p>
      Representation in cases in which injunctions were obtained on behalf of
      clients involving billions of dollars:
    </p>
    <ul>
      <li>
        Independent Living Center of Southern California v. Shewry, Central
        District of California, injunction obtained on August 18, 2008;
      </li>

      <li>
        Independent Living Center of Southern California v. Shewry, Central
        District of California, injunction obtained on November 17, 2008;
      </li>

      <li>
        Managed Pharmacy Care v. Maxwell-Jolly, Central District of California,
        injunction obtained on February 27, 2009;
      </li>

      <li>
        California Pharmacists Association v. Maxwell-Jolly, Central District of
        California, injunction obtained on May 5, 2010.
      </li>
      <li>
        Managed Pharmacy Care v. Sebelius, Central District of California,
        injunction obtained on December 28, 2011;
      </li>
      <li>
        California Medical Transportation Association v. Douglas, Central
        District of California, injunction obtained on January 10, 2012.
      </li>
    </ul>
    <Heading as="h2">
      <!--  -->
      Healthcare Recognitions
    </Heading>
    <p>
      Los Angeles Business Journal 2012 Healthcare Leadership Award, Lifetime
      Achievement Award (finalist) – Presented to Mr. Stanley L. Friedman
    </p>
  </Article>
</template>

<script setup>
defineOptions({ name: "ViewDisclaimer" });
import Article from "../components/Article.vue";
import Heading from "../components/Heading.vue";
</script>
